module.exports = __webpack_public_path__ + "static/bdbf1b.png";